import React, { useEffect, useRef } from 'react';
import * as d3 from 'd3';
import { sankey, sankeyLinkHorizontal } from 'd3-sankey';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../stores/store';
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import useFetchData from '../../../hooks/useFetchData';
import { useSetMenu } from "../../../hooks/useSetMenu";

const SankeyDiagram = observer(() => {
  const d3Container = useRef(null);
  const { mainStore, timeLineStore } = useStore();
  const axiosPrivate = useAxiosPrivate();
  useFetchData(axiosPrivate, "/MergersAndAcquisitions/GetMAndAActivities", timeLineStore);
  useSetMenu(mainStore.SankeyDiagramMenuType, mainStore.SankeyDiagramMenuNo);
  useEffect(() => {
    if (timeLineStore.timeLine.length > 0) {

  
      const width = 1500;
      const height = 3200;

     const zoom = d3.zoom()
     .scaleExtent([0.5, 8])
     .translateExtent([[0, 0], [1200, 800]])
     .on('zoom', (event) => {
       g.attr('transform', event.transform);
     });

   const svg = d3.select(d3Container.current)
     .attr('viewBox', `0 0 1500 3200`)
     .call(zoom);

   svg.selectAll("*").remove();

   const g = svg.append('g');
  

      const nodesByName = new Map();
  

      timeLineStore.timeLine.forEach(d => {
        if (!nodesByName.has(d.acquirerName)) {
          nodesByName.set(d.acquirerName, { name: d.acquirerName });
        }
        if (!nodesByName.has(d.targetName)) {
          nodesByName.set(d.targetName, { name: d.targetName });
        }
      });
  

      const nodes = Array.from(nodesByName.values());
      const nodeIndex = new Map(nodes.map((d, i) => [d.name, i]));
  

      const links = timeLineStore.timeLine.map(d => ({
        source: nodeIndex.get(d.acquirerName),
        target: nodeIndex.get(d.targetName),
        value: 1,
      })).filter(d => d.source !== undefined && d.target !== undefined);
  

      const nonCircularLinks = links.filter(link => link.source !== link.target);
  

      const sankeyGraph = sankey()
        .nodeWidth(5)
        .nodePadding(10)
        .extent([[1, 1], [width - 1, height - 5]])({
          nodes: nodes.map(d => Object.assign({}, d)),
          links: nonCircularLinks,
        });
  

      svg.append('g')
        .selectAll("rect")
        .data(sankeyGraph.nodes)
        .enter().append("rect")
          .attr("x", d => d.x0)
          .attr("y", d => d.y0)
          .attr("height", d => d.y1 - d.y0)
          .attr("width", sankeyGraph.nodeWidth)
          .attr("fill", "#555");
  

      svg.append("g")
        .selectAll("path")
        .data(sankeyGraph.links)
        .enter().append("path")
          .attr("d", sankeyLinkHorizontal())
          .attr("stroke-width", d => Math.max(1, d.width))
          .attr("stroke", "#000")
          .attr("fill", "none")
          .attr("stroke-opacity", 0.5);

      svg.append("g")
        .style("font", "10px sans-serif")
        .selectAll("text")
        .data(sankeyGraph.nodes)
        .enter().append("text")
          .attr("x", d => d.x0 < width / 2 ? d.x1 + 6 : d.x0 - 6)
          .attr("y", d => (d.y1 + d.y0) / 2)
          .attr("dy", "0.35em")
          .attr("text-anchor", d => d.x0 < width / 2 ? "start" : "end")
          .text(d => d.name);
    }
  }, [timeLineStore.timeLine]);

  return (
    <div>
      <svg
        ref={d3Container}
        style={{ width: '100%', height: '100%', minHeight: '800px', border: '1px solid #ccc' }}
      />
    </div>
  );
});

export default SankeyDiagram;
